<template>
	<div class="box">
		<div class="null-page" v-show="yes"></div>

		<div class="member-index" v-loading="loading">
			<div class="member-top">
				<div class="info-wrap" style="       border-radius: 12px !important;
    border: 1px solid #e9e9e900;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px; ">
					<div class="info-top">
						<div class="avtar">
							<router-link to="/member/info">
								<img v-if="member.headimg" :src="$img(member.headimg)" @error="member.headimg = defaultHeadImage" />
								<img v-else :src="$img(defaultHeadImage)" />
							</router-link>
						</div>
						<div class="member-wrap">
							<template v-if="member">
								<div class="name member-name" v-if="member.nickname">
									<router-link to="/member/info" style="font-family: 'sukhumvittadmai2';">คุณ {{ member.nickname }}</router-link>
								</div>
								<div class="level" v-if="member.member_level_name">ระดับ {{ member.member_level_name }}</div>
								<div class="growth" style="font-family: 'sukhumvittadmai2';">
									
									<el-progress :stroke-width="7" :percentage="progress" :show-text="text"></el-progress>
									<div></div>
								</div>
							</template>
							<div class="no-login name" v-else>ไม่ได้เข้าสู่ระบบ</div>
						</div>
					</div>
					<div class="account">
						<div class="content">
							<div class="item">
								<router-link to="/member/my_coupon" class="item-content">
									<img src="https://i.imgur.com/oyRgvOj.png" alt />
									<div class="name" style="font-weight: bold;  font-family: 'sukhumvittadmai2'; font-size:15px;">คูปอง</div>
									<div class="num" v-if="member.member_id && couponNum">{{ couponNum }} ใบ</div>
									<div class="num" v-else>0</div>
								</router-link>
							</div>

							<div class="item">
								<router-link to="/member/my_point" class="item-content">
									<img src="https://i.imgur.com/ptv6Ekh.png" alt />
									<div class="name" style="font-weight: bold;  font-family: 'sukhumvittadmai2'; font-size:15px;">คะแนน</div>
									<div class="num" v-if="member.point">{{ member.point }} P</div>
									<div class="num" v-else>0</div>
								</router-link>
							</div>
							<div class="item">
								<router-link to="/member/account" class="item-content">
									<img src="https://i.imgur.com/xGzv9a0.png" alt />
									<div class="name" style="font-weight: bold;  font-family: 'sukhumvittadmai2'; font-size:15px;">เงินในบัญชี</div>
									<div class="num" v-if="member.balance || member.balance_money">
										{{ (parseFloat(member.balance) + parseFloat(member.balance_money)).toFixed(2) }} ฿
									</div>
									<div class="num" v-else>0</div>
								</router-link>
							</div>
							<div class="item">
								<router-link to="/member/account" class="item-content">
									<img src="https://i.imgur.com/Ql0Dpun.png" alt />
									<div class="name" style="font-weight: bold;  font-family: 'sukhumvittadmai2'; font-size:15px;">เข้าสู่ระบบ</div>
									<div class="num" v-if="member.sign_days_series || member.sign_days_series">
										{{ member.sign_days_series }} วัน
									</div>
									<div class="num" v-else>0</div>
								</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="collection" style=" border-radius: 0px;     border-radius: 12px !important;
    border: 1px solid #e9e9e900;     box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;     font-weight: bold;     opacity: 0;
    font-family: 'sukhumvittadmai2';
    font-size: 14px; ">
					<div class="title" style="font-weight: bold;">สินค้าที่ชอบ</div>
					<div class="xian"></div>
					<div class="item-wrap">
						<div class="item">
							<div class="num" style="    font-weight: bold;
    font-family: 'sukhumvittadmai';
    font-size: 13px;">ทั้งหมด {{ goodsTotal }} ชิ้น</div>
							<div class="collect" style="    font-weight: bold;
    font-family: 'sukhumvittadmai';
    font-size: 13px;">คุณสามารถเช็คได้</div>
						</div>
					</div>
				</div>
			</div>
			<div class="member-bottom">
				<div class="my-order" style="border-radius: 11px;
       box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;
   ">
					
					<div class="xian"></div>
					<div class="order-item">
						<router-link to="/member/order_list?status=waitpay" class="item">
							<i class="iconfont icondaifukuan"></i>
							<div v-if="orderNum.waitPay" class="order-num">{{ orderNum.waitPay }}</div>
							<div class="name">รอดำเนินการ</div>
						</router-link>
						<router-link to="/member/order_list?status=waitsend" class="item">
							<i class="iconfont icondaifahuo"></i>
							<div v-if="orderNum.readyDelivery" class="order-num">{{ orderNum.readyDelivery }}</div>
							<div class="name">รอจัดส่ง</div>
						</router-link>
						<router-link to="/member/order_list?status=waitconfirm" class="item">
							<i class="iconfont icontubiaolunkuo-"></i>
							<div v-if="orderNum.waitDelivery" class="order-num">{{ orderNum.waitDelivery }}</div>
							<div class="name">ที่จะได้รับ</div>
						</router-link>
						<router-link to="/member/order_list?status=waitrate" class="item">
							<i class="iconfont icondaipingjia"></i>
							<div v-if="orderNum.waitEvaluate" class="order-num">{{ orderNum.waitEvaluate }}</div>
							<div class="name">รอรีวิว</div>
						</router-link>
						<router-link to="/member/activist" class="item">
							<i class="iconfont iconshouhou"></i>
							<div v-if="orderNum.refunding" class="order-num">{{ orderNum.refunding }}</div>
							<div class="name">คืน/หลังการขาย</div>
						</router-link>
					</div>
					<div v-if="orderList.length">
						<div class="order-goods-wrap" v-for="(orderItem, orderIndex) in orderList" :key="orderIndex">
							<div class="order-goods" v-for="(goodsItem, goodsIndex) in orderItem.order_goods" :key="goodsIndex">
								<div class="goods-item">
									<div class="goods-img" @click="$router.pushToTab({ path: '/sku-' + goodsItem.sku_id })">
										<img :src="$img(goodsItem.sku_image, { size: 'mid' })" @error="imageErrorOrder(orderIndex, goodsIndex)" />
									</div>
									<div class="info-wrap">
										<div class="goods-name" @click="$router.pushToTab({ path: '/sku-' + goodsItem.sku_id })" style="    
    font-family: 'sukhumvittadmai';       height: 32px;  font-weight: bold;
" >{{ goodsItem.sku_name }}</div>
										<div class="price" style="    
    font-family: 'sukhumvittadmai2';  font-weight: bold;
"> ฿ {{ goodsItem.price }}</div>
									</div>
									<div class="payment" style="    
    font-family: 'sukhumvittadmai'
"    >{{ resettext(orderItem.order_status_name) }}</div>

									<div class="goods-detail" @click="orderDetail(orderItem)">
										<p style="    
    font-family: 'sukhumvittadmai';   font-size: 13px;
">ดูรายละเอียด</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="empty" v-else>
						<img style="        max-width: 30%;
    margin-left: auto;
    margin-bottom: 45px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    -webkit-transform-origin-y: center; " src="@/assets/images/member-empty.png" alt />
						<div><router-link to="/">คุณซื้อน้อยเกินไป，มันว่างเปล่าทั้งหมด，ไปเลือกผลิตภัณฑ์ที่เหมาะสม！</router-link></div>
					</div>
				</div>
				<div class="bottom-right">
					<div class="my-foot" style="border: 1px solid #e9e9e900; border-radius: 13px;      box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;     margin-top: -173px;
    position: absolute;
  ">
						<div class="title" style="font-weight: bold;     border-bottom: 1px solid #fe2f2f00;  font-weight: bold;
    font-family: 'sukhumvittadmai2'; 
    font-size: 14px; ">สินค้าดูล่าสุด</div>
						<div class="xian" style="margin-left: 1px;"></div>
						<div class="foot-content" v-for="(item, index) in footList" :key="item.goods_id">
							<div class="foot-item" @click="$router.pushToTab({ path: '/sku-' + item.sku_id })">
								<div class="foot-img"><img :src="$img(item.sku_image, { size: 'mid' })" @error="imageErrorFoot(index)" /></div>
								<div class="foot-info">
									<div class="foot-name" style="">{{ item.goods_name }}</div>
									<div class="foot-price" style="font-weight: bold;
    font-family: 'sukhumvittadmai';">฿{{ item.discount_price }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		orderNum,
		couponNum,
		footprint,
		levelList
	} from '@/api/member/index';
	import {
		goodsCollect
	} from '@/api/member/collection';
	import {
		apiOrderList
	} from '@/api/order/order';
	import {
		mapGetters
	} from 'vuex';
	export default {
		name: 'member',
		components: {},
		data: () => {
			return {
				couponNum: 0,
				orderNum: {
					waitPay: 0, //การชําระเงินที่รอดําเนินการ
					readyDelivery: 0, //การจัดส่งที่รอดําเนินการ
					waitDelivery: 0, //ที่จะได้รับ
					refunding: 0 // การคืนเงินกําลังดําเนินการอยู่
				},
				orderList: [],
				orderStatus: 'all',
				footInfo: {
					page: 1,
					page_size: 7
				},
				total: 0,
				footList: [],
				currentPage: 1,
				loading: true,
				goodsTotal: 0,
				state: '',
				growth: '',
				levelList: [],
				member_level: {},
				progress: 0,
				yes: true
			};
		},
		created() {
			this.getCouponNum();
			this.getOrderNum();
			this.getOrderList();
			this.getFootprint();
			this.getGoodsCollect();
			// this.$store.dispatch("member/member_detail")

			this.$forceUpdate()
		},

		computed: {
			...mapGetters(['defaultHeadImage', 'defaultGoodsImage', 'member'])
		},
		watch: {
			member: {
				handler() {
					console.log(this.member)
					if (this.member) this.getLevelList();
				},
				immediate: true,
				deep: true,

			}
		},
		mounted() {
			let self = this;
			setTimeout(function() {
				self.yes = false;
			}, 300);
		},
		methods: {
			getLevelList() {
				levelList()
					.then(res => {
						if (res.data && res.code == 0) {
							this.levelList = res.data;
							let listIndex = this.levelList.findIndex(item => item.level_id == this.member.member_level);

							const max = this.levelList.length;
							if (max > listIndex + 1) {
								if (this.member.growth > this.levelList[listIndex + 1].growth) {
									this.progress = 100;
								} else {
									this.progress = (this.member.growth / this.levelList[listIndex + 1].growth) * 100;
								}
							} else {
								this.progress = 100;
							}
						} else {
							this.$notify.error({title: 'Error',message: err.message});
						}
					})
					.catch(err => {
						console.log(err.message);
					});
			},
			//รับจํานวนคูปอง
			getCouponNum() {
				couponNum()
					.then(res => {
						this.couponNum = res.data;
					})
					.catch(err => {
						console.log(err.message);
					});
			},
			//รับปริมาณการสั่งซื้อ
			getOrderNum() {
				orderNum({
						order_status: 'waitpay,waitsend,waitconfirm,waitrate,refunding'
					})
					.then(res => {
						console.log(res,'รับปริมาณการสั่งซื้อ')
						if (res.code == 0) {
							this.orderNum.waitPay = res.data.waitpay;
							this.orderNum.readyDelivery = res.data.waitsend;
							this.orderNum.waitDelivery = res.data.waitconfirm;
							this.orderNum.waitEvaluate = res.data.waitrate;
							this.orderNum.refunding = res.data.refunding;
						}
					})
					.catch(err => {
						console.log(err.message);
					});
			},
			resettext(item) {
				if(item=="ปิด"){
					
					return "ออเดอร์ถูกยกเลิก"
				}else if(item=="รับ"){
					
					return "ออเดอร์จัดส่งแล้ว"
				}
				
				else{
				return item
				}
				
				
			},
			//รับรายการคําสั่งซื้อ
			getOrderList() {
				apiOrderList({
						order_status: this.orderStatus,
						page: 1,
						page_size: 3
					})
					.then(res => {
						if (res.code == 0 && res.data) {
							this.orderList = res.data.list;
						}
						this.loading = false;
					})
					.catch(err => {
						this.loading = false;
						this.$notify.error({title: 'Error',message: err.message});
					});
			},
			//รับรอยเท้าของฉัน
			getFootprint() {
				footprint(this.footInfo)
					.then(res => {
						if (res.code == 0 && res.data) {
							this.footList = res.data.list;
							this.total = res.data.count;
						}
					})
					.catch(err => {
						console.log(err.message);
					});
			},
			orderDetail(data) {
				switch (parseInt(data.order_type)) {
					case 2:
						// ใบสั่งรับสินค้า
						this.$router.push({
							path: '/member/order_detail_pickup',
							query: {
								order_id: data.order_id
							}
						});
						break;
					case 3:
						// การปฏิบัติตามคําสั่งซื้อในพื้นที่
						this.$router.push({
							path: '/member/order_detail_local_delivery',
							query: {
								order_id: data.order_id
							}
						});
						break;
					case 4:
						// คําสั่งซื้อเสมือน
						this.$router.push({
							path: '/member/order_detail_virtual',
							query: {
								order_id: data.order_id
							}
						});
						break;
					default:
						this.$router.push({
							path: '/member/order_detail',
							query: {
								order_id: data.order_id
							}
						});
						break;
				}
			},
			imageErrorOrder(orderIndex, goodsIndex) {
				this.orderList[orderIndex].order_goods[goodsIndex].sku_image = this.defaultGoodsImage;
			},
			imageErrorFoot(index) {
				this.footList[index].sku_image = this.defaultGoodsImage;
			},
			getGoodsCollect() {
				goodsCollect()
					.then(res => {
						this.goodsTotal = res.data.count;
					})
					.catch(err => {
						this.loading = false;
						console.log(err.message);
					});
			}
		}
	};
</script>
<style lang="scss" scoped>
	.box {
		width: 100%;
		position: relative;
	}

	.null-page {
		width: 100%;
		height: 730px;
		background-color: #ffffff;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}

	.member-index {
		.member-top {
			width: 100%;
			display: flex;

			.info-wrap {
				width: 75%;
				height: 160px;
				border: 1px solid #e9e9e9;
				background: #ffffff;
				display: flex;

				.info-top {
					display: flex;
					align-items: center;
					margin: 22px;
					margin-right: 0;
					width: 300px;
					border-right: 1px solid #e9e9e9;

					.avtar {
						width: 84px;
						height: 84px;
						margin: 20px 0 10px 0;
						border: 1px solid #e9e9e9;
						border-radius: 50%;
						overflow: hidden;
						display: block;
						cursor: pointer;
						margin-left: 21px;
						text-align: center;
						line-height: 84px;

						img {
							display: inline-block;
						}
					}

					.member-wrap {
						margin-left: 20px;

						.name {
							font-size: 18px;
							font-weight: 600;
							cursor: pointer;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						.growth {
							display: flex;
							align-items: center;
						}

						.el-progress {
							width: 100px;
						}

						.level {
							padding: 3px 4px;
							line-height: 1;
							color: #ffffc1;
							margin: 6px 0;
							cursor: default;
							background: linear-gradient(#636362, #4e4e4d);
							border-radius: 3px;
							display: inline-block;
						}
					}
				}

				.account {
					width: 400px;
					display: flex;
					align-items: center;

					.content {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;

						.item {
							flex: 1;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;

							.item-content {
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;
							}

							img {
								width: 50px;
								height: 50px;
							}

							.name {
								margin-top: 5px;
								color: #666666;

								&:hover {
									color: $base-color;
								}
							}

							.num {
								color: $ns-text-color-black;
							}
						}
					}
				}
			}

			.collection {
				background: #ffffff;
				margin-left: 20px;
				width: 210px;
				border: 1px solid #e9e9e9;
				padding-left: 20px;

				.title {
					padding: 10px 0;
					display: inline-block;
					border-bottom: 1px solid $base-color;
				}

				.xian {
					height: 1px;
					background: #f1f1f1;
				}

				.item-wrap {
					display: flex;
					justify-content: center;
					align-items: center;

					.item {
						flex: 1;
						margin-top: 37px;

						.num {}

						.collect {
							color: #666666;
						}
					}
				}
			}
		}

		.member-bottom {
			width: 100%;
			margin-top: 15px;
			height: 553px;
			display: flex;
			overflow: hidden;

			.my-order {
				width: 75%;
				background-color: #ffffff;

				.order-title {
					font-size: $ns-font-size-base;
					padding: 10px 0;
					margin-left: 15px;
					border-bottom: 1px solid $base-color;
					display: inline-block;
				}

				.xian {
					height: 1px;
					background: #f1f1f1;
					margin-left: 15px;
				}

				.order-item {
					display: flex;
					justify-content: center;
					align-content: center;
					font-family: 'sukhumvittadmai2';
					font-weight:800;
					font-size: 19px !important;
					.item {
						flex: 1;
						text-align: center;
						height: 85px;
						padding-top: 20px;
						cursor: pointer;
						position: relative;

						&:hover {
							background: #ffffff;
							//box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
						}

						.order-num {
							position: absolute;
							top: 23px;
							right: 25px;
							background: $base-color;
							border-radius: 50%;
							width: 18px;
							height: 18px;
							line-height: 18px;
							color: #ffff;
						}

						i {
							font-size: 30px;
						}

						.name {
							font-size: $ns-font-size-base;
						}
					}
				}

				.order-goods {
					.goods-item {
						display: flex;
						padding: 14px;
						border-top: 1px solid #f1f1f1;

						.goods-img {
							flex: 1;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;

							img {
								width: 60px;
								height: 60px;
							}
						}

						.info-wrap {
							flex: 3;
							width: 80%;

							.goods-name {
								height: 46px;
								overflow: hidden;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
							}

							.price {
								color: $base-color;
							}
						}

						.payment {
							flex: 2;
							display: flex;
							align-items: center;
							justify-content: center;
							text-overflow: ellipsis;
						}

						.goods-detail {
							flex: 2;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;

							&:hover {
								color: $base-color;
							}
						}
					}
				}
			}

			.bottom-right {
				.my-foot {
					background: #ffffff;
					margin-left: 20px;
					width: 230px;

					.title {
						font-size: $ns-font-size-base;
						padding: 10px 0;
						display: inline-block;
						border-bottom: 1px solid $base-color;
						margin: 0 15px;
					}

					.xian {
						margin-left: 15px;
						background: #f1f1f1;
						height: 1px;
					}

					.foot-content {
						.foot-item {
							display: flex;
							padding: 10px 0;
							margin: 0 15px;

							.foot-img {
								width: 57px;
								height: 57px;
								cursor: pointer;

								img {
									width: 100%;
									height: 100%;
								}
							}

							.foot-info {
								margin-left: 5px;
								display: flex;
								flex-direction: column;
								justify-content: space-between;

								.foot-name {
									overflow: hidden;
									text-overflow: ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									-webkit-box-orient: vertical;
									line-height: 1;
									width: 140px;
								}

								.foot-price {
									color: $base-color;
								}
							}
						}
					}
				}
			}
		}
	}

	.empty {
		text-align: center;
		margin-top: 65px;
	}
	.member-index .member-bottom .my-order .order-item .item {
	    flex: 1;
	    text-align: center;
	    height: 44px;
	    padding-top: 20px;
	    cursor: pointer;
	    position: relative;
	}
	.member-index .member-bottom{
	    width: 100%;
	    margin-top: 15px;
	    height: 642px;
	    display: flex;
	    overflow: hidden;
	}
	.el-menu {
	    border-radius: 15px;
	    border-right: solid 1px #e6e6e600;
	    list-style: none;
	    position: relative;
	    margin: 0;
	    padding-left: 0;
	    background-color: #fff;
	}.member-index .member-top .info-wrap {
    width: 75%;
    height: 160px;
        border-radius: 0px;
    
   
    background: #ffffff;
    display: flex;
}
.member-index .member-bottom .my-order .order-item .item {
    flex: 1;
    text-align: center;
    height: 34px;
    padding-top: 9px;
    cursor: pointer;
    position: relative;
}.member-index .member-bottom .my-order .order-item .item .order-num {
   
    top: 13px;
  
}.member-index .member-bottom{
    width: 100%;
    margin-top: 15px;
    height: 642px;
    display: flex;
    overflow: hidden;
}

.member-index .member-top .collection{
    background: #ffffff;
    margin-left: 20px;
    width: 230px;
    border: 1px solid #e9e9e900;
    padding-left: 20px;
}.member-index .member-top .collection .xian{
    height: 1px;
    margin-left: -23px;
    background: #f1f1f1;
}.member-index .member-top .collection .title{
    padding: 10px 0;
    display: inline-block;
    border-bottom: 1px solid #fe2f2f00;
}.member-index .member-top .collection {
    background: #ffffff;
    margin-left: 20px;
    width: 230px;
    border-radius: 13px !important;
    border: 1px solid #e9e9e900;
    padding-left: 20px;
}.member-index .member-top .info-wrap .account{
    width: 529px;
    display: flex;
    align-items: center;
}.member-index .member-bottom .my-order .xian{
    height: 1px;
    background: #f1f1f1;
    margin-left: 0px;
}.member-index .member-bottom .my-order .order-title[data-v-16c51892] {
    font-size: 14px;
    padding: 10px 0;
    margin-left: 26px;
    border-bottom: 1px solid #fe2f2f00;
    display: inline-block;
}.member-index .member-bottom .my-order .order-item .item[data-v-16c51892] {
    flex: 1;
    text-align: center;
    height: 44px;
    padding-top: 9px;
    cursor: pointer;
    position: relative;
}.member-index .member-bottom .my-order .xian {
    height: 1px;
    background: #ffffff;
    margin-left: 0px;
}.member-index .member-bottom .my-order .order-item .item .name {
    font-size: 14px;
}.member-index .member-bottom .my-order .order-item .item .order-num {
        font-size: 5px;
    right: 39px;
    
}.member-index .member-bottom .my-order .xian {
    height: 1px;
    background: #ffffff00;
    margin-left: 0px;
}.member-index .member-top .info-wrap .info-top .avtar{
    width: 100px;
    height: 100px;
    margin: 11px 0 5px 0;
    border: 0px solid #ffffff00;
    border-radius: 6px;
    overflow: hidden;
    display: block;
    cursor: pointer;
    margin-left: 6px;
    text-align: center;
    box-shadow: rgb(50 50 93 / 40%) 0px 2px 5px -1px, rgb(0 0 0 / 47%) 0px 1px 3px -1px;
    line-height: 84px;
}.member-index .member-bottom .bottom-right .my-foot .foot-content .foot-item .foot-info .foot-name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    line-height: 1.4;
    width: 149px;
}
</style>
